export default {"src":"/_next/static/media/indoor_fireplace.a5470cd0.svg","height":100,"width":100};